{
  "app": {
    "nom": "CAI — Centre d'Alertes i Incidències",
    "nomCurt": "CAI",
    "logo": "CAI",
    "descripcio": "Centre d'Alertes i Incidències",
    "organitzacio": "bonÀrea · {{entorn}}",
    "logoAlt": "BAtech"
  },
  "login": {
    "titol": "CAI — Centre d'Alertes i Incidències",
    "subtitol": "Portal de gestió d'activacions, guàrdies i comunicacions de crisi de bonÀrea.",
    "boto": "Iniciar sessió amb Microsoft",
    "peu": "Accés restringit a personal intern amb compte bonÀrea.",
    "mock": "Mode de desenvolupament: sessió simulada",
    "perfilMock": "Perfil simulat",
    "titolMarca": "Centre d'Alertes i Incidències",
    "peu2": "Ús subjecte a la política de seguretat corporativa.",
    "marca": "BAtech · bonÀrea"
  },
  "perfilsMock": {
    "ADMIN": "Administrador",
    "RESPONSABLE_DEPARTAMENT": "Responsable de departament",
    "RESPONSABLE_SEGURETAT": "Responsable de seguretat",
    "TECNIC": "Tècnic de guàrdia",
    "STANDARD": "Standard (reporta)"
  },
  "nav": {
    "principal": "Navegació principal",
    "torna": "← {{seccio}}",
    "seccions": {
      "centre": "Centre de control",
      "activacions": "Activacions",
      "guardies": "Guàrdies",
      "analisi": "Anàlisi",
      "ajustos": "Configuració"
    },
    "pestanyes": {
      "calendari": "Calendari",
      "cobertura": "Cobertura",
      "sollicituds": "Sol·licituds",
      "experts": "Experts",
      "historial": "Historial",
      "indicadors": "Indicadors",
      "informes": "Informes",
      "recurrents": "Recurrents",
      "registre": "Registre"
    }
  },
  "cerca": {
    "placeholder": "Cerca activacions, persones…"
  },
  "idioma": {
    "etiqueta": "Idioma",
    "ca": "Català",
    "es": "Castellano"
  },
  "sessio": {
    "tanca": "Tanca la sessió",
    "carregant": "Carregant…",
    "iniciant": "Iniciant la sessió…",
    "menu": "Menú del compte",
    "canviaCompte": "Canvia de compte",
    "elMeuMobil": "El meu mòbil"
  },
  "telefon": {
    "onboardingTitol": "Confirma el teu mòbil",
    "onboardingText": "El CAI t'avisarà per SMS i trucada en aquest número quan estiguis de guàrdia o s'activi un servei. És el teu mòbil?",
    "onboardingSense": "No tens cap mòbil al teu perfil. Afegeix-ne un per continuar.",
    "titolPerfil": "El meu mòbil",
    "textPerfil": "Número on el CAI t'enviarà els avisos per SMS i trucada.",
    "etiqueta": "Mòbil",
    "placeholder": "6XX XXX XXX",
    "ajuda": "9 dígits, ha de començar per 6 o 7.",
    "invalid": "El mòbil ha de tenir 9 dígits i començar per 6 o 7.",
    "esCorrecte": "Sí, és correcte",
    "canvia": "Canvia el número",
    "desa": "Desa",
    "cancella": "Cancel·la",
    "desat": "Mòbil desat"
  },
  "estatPagina": {
    "senseAccesTitol": "Sense accés",
    "senseAccesText": "No tens permís per consultar aquesta pantalla.",
    "noTrobatTitol": "Pàgina no trobada",
    "noTrobatText": "La pàgina que cerques no existeix.",
    "errorTitol": "No s'ha pogut carregar",
    "errorText": "S'ha produït un error en connectar amb el servidor.",
    "reintenta": "Torna-ho a provar",
    "tornaInici": "Torna a l'inici",
    "pendentText": "Pantalla {{id}} · en construcció."
  },
  "accions": {
    "desar": "Desar",
    "cancellar": "Cancel·lar",
    "enviar": "Enviar",
    "seguent": "Següent",
    "enrere": "Enrere",
    "editar": "Editar",
    "eliminar": "Eliminar",
    "cerca": "Cerca",
    "confirmar": "Confirmar",
    "acceptar": "Acceptar",
    "tancar": "Tancar",
    "exportar": "Exportar",
    "tria": "Tria…",
    "senseResultats": "Cap resultat"
  },
  "tempsReal": {
    "connectat": "Temps real connectat",
    "connectant": "Connectant temps real…",
    "desconnectat": "Temps real desconnectat"
  },
  "tipusActivacio": {
    "AVIS": "Avís",
    "INCIDENCIA": "Incidència",
    "CRITICA": "Crítica"
  },
  "comunicacio": {
    "PREVENTIVA": "Comunicació preventiva",
    "REACTIVA": "Comunicació reactiva",
    "CRITICA": "Comunicació crítica"
  },
  "tipusArea": {
    "GUARDIA_IT": "Guàrdia",
    "CRISI": "Crisi"
  },
  "estatActivacio": {
    "OBERTA": "Oberta",
    "EN_CURS": "En curs",
    "RESOLTA": "Resolta",
    "MITIGADA": "Mitigada",
    "CANCELLADA": "Cancel·lada",
    "FINALITZADA": "Finalitzada"
  },
  "estatDestinatari": {
    "PENDENT": "Pendent",
    "ENVIAT": "Enviada",
    "LLIURAT": "Lliurada",
    "LLEGIT": "Llegida",
    "CONFIRMAT": "Confirmada",
    "FALLIT": "Fallida",
    "EXPIRAT": "Expirada",
    "EN_ESPERA": "En espera",
    "NO_NOTIFICAT": "No notificat"
  },
  "blocDestinatari": {
    "TECNIC_GUARDIA": "Tècnic de guàrdia",
    "USUARIS_INFORMAR": "Usuaris a informar",
    "TECNIC_EXPERT": "Tècnic expert",
    "ADDICIONAL": "Destinataris addicionals"
  },
  "canal": {
    "PUSH": "Push",
    "PUSH_CRITICA": "Push crítica",
    "EMAIL": "Correu electrònic",
    "TRUCADA": "Trucada"
  },
  "cobertura": {
    "COBERTA": "Coberta",
    "SENSE_COBERTURA": "Sense cobertura"
  },
  "ambit": {
    "GLOBAL": "Global",
    "DEPARTAMENT": "Departament",
    "AREA": "Àrea",
    "SERVEI": "Servei"
  },
  "avisos": {
    "nova": "Nova activació",
    "critica": "Activació crítica",
    "mencio": "Menció al xat",
    "missatgeA": "Nou missatge a {{codi}}"
  }
}
